import { LoadPanel } from "devextreme-react";
import React, { Component } from "react";
import Modal from "react-modal"; //npm install --save react-modal
const customStyles = {
  content: {
    width: "85%",
    height: "80%",
  },
};
const customMaxStyles = {
  content: {
    width: "100%",
    height: "100%",
  },
};
export class LocateVehicleComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      modalStyle: customStyles,
      isMaximize: true,
      isMinimize: false,
    };
  }
  render() {
    const locateMapUrl = `${process.env.REACT_APP_TRACKING_URL}?accountId=${
      this.props?.transporterId ?? 0
    }&locationId=${this.props?.locationId ?? 0}&userId=0&vgTypeId=0&rideId=${
      this.props?.rideId ?? 0
    }`;
    return (
      <>
        <Modal
          ariaHideApp={false}
          isOpen={true}
          style={this.state.modalStyle}
          className={"react-modal"}
          shouldCloseOnOverlayClick={false}
          contentLabel="Example Modal"
        >
          <div id="divLoading">
            <div className="modal-header">
              <h6 className="modal-title">Locate Vehicle</h6>
              <div className="modal-button">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.props.onClose();
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Maximize"
                  onClick={() => {
                    this.setState((prev) => ({
                      ...prev,
                      modalStyle: customMaxStyles,
                      isMaximize: false,
                      isMinimize: true,
                    }));
                  }}
                  style={{ display: this.state.isMaximize ? "block" : "none" }}
                >
                  <span aria-hidden="true">☐</span>
                </button>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Maximize"
                  onClick={() => {
                    this.setState((prev) => ({
                      ...prev,
                      modalStyle: customStyles,
                      isMaximize: true,
                      isMinimize: false,
                    }));
                  }}
                  style={{ display: this.state.isMinimize ? "block" : "none" }}
                >
                  <span aria-hidden="true">⧉</span>
                </button>
              </div>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <small>
                    {`Below is the current location of the vehicle(s) `}
                    <i>
                      <strong className="text-danger">
                        {this.props?.vehicleNo ?? ""}
                      </strong>
                    </i>
                    .
                  </small>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="widget-map-container">
                    <iframe
                      style={{ height: "80vh", width: "100%" }}
                      frameBorder="0"
                      scrolling="no"
                      allowtransparency="true"
                      src={locateMapUrl}
                      onLoad={() => {
                        this.setState((prev) => ({
                          ...prev,
                          isLoading: false,
                        }));
                      }}
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          position={{ of: "#divLoading" }}
          visible={this.state.isLoading}
          showIndicator={true}
          shading={true}
          showPane={true}
          closeOnOutsideClick={false}
        />
      </>
    );
  }
}
